import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MessageRelation } from '../models/message-relation';
import { Document } from '../models';


@Component({
    selector: 'app-tracking-message-relations-item',
    templateUrl: './tracking-message-relations-item.component.html',
    styleUrls: ['./tracking-message-relations-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class TrackingMessageRelationsItemComponent { // implements OnChanges {
  @Input() messageRelation: MessageRelation = null;
  @Input() document: Document = null;
  @Input() original = true;
  @Output() openDocument = new EventEmitter<number>();
  @Output() openInterchange = new EventEmitter<number>();

  get relationDocumentId(): number {
    return this.original ? this.messageRelation.DocumentId_Original : this.messageRelation.DocumentId_Related;
  }

  get relationInterchangeId(): number {
    return this.original ? this.messageRelation.InterchangeInId_Original : this.messageRelation.InterchangeInId_Related;
  }

  get isDocumentRelation(): boolean {
    return !!this.messageRelation.DocumentId_Original;
  }

  get isThisDocument(): boolean {
    return this.relationDocumentId === this.document.DocumentId;
  }

  get isThisInterchange(): boolean {
    return this.relationInterchangeId === this.document.InterchangeIn.InterchangesId;
  }

  get itemType(): string {
    if (this.isDocumentRelation) {
      return this.isThisDocument ? 'TD' : 'OD';
    }
    else {
      return this.isThisInterchange ? 'TI' : 'OI';
    }
  }

  openRelation(): void {
    if (this.isDocumentRelation) {
      this.openDocument.emit(this.relationDocumentId);
    }
    else {
      this.openInterchange.emit(this.relationInterchangeId);
    }
  }
}
